import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import {Immagine} from '../beans/immagine';


@Injectable()
export class ImmaginiBattezzatiService {


	private heroesUrl='api/immagini_libri_battesimi';
	private headers = new Headers({'Content-Type': 'application/json'});


	constructor (private http:Http){}

	getImmagini(): Promise<Immagine[]> {
		return this.http.get(this.heroesUrl)
				.toPromise()
				.then(response=>response.json().data as Immagine[])
				.catch(this.handleError);
	} 

	getImmagine(id: number): Promise<Immagine>{
		const url = `${this.heroesUrl}/${id}`;
		return this.http.get(url).toPromise().then(response=> response.json().data as Immagine)
		.catch(this.handleError);
	}

private handleError(error: any){
	console.error('Error in libri app',error);
	return Promise.reject(error.message||error);
}


}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/services/immagini-battezzati.service.ts